import React from 'react';

export default function About({ aboutRef }) {
  return (
    <div ref={aboutRef} className='bg-gradient-to-b from-[#202947] to-[#444444] flex flex-col min-h-screen justify-center z-10 relative'>

      <div className='flex flex-col md:flex-row justify-center gap-4 p-24'>
        <div className='flex-[3] flex-col  p-4 flex items-center justify-center h-auto '>
          <img src='assats/images/coding.png' alt='profile' className='h-[245px] md:h-auto w-auto '  />
          <button className='hover:text-[#213a57] hover:bg-[#80ed99]   mt-4 p-2 w-[200px] md:w-[200px]  rounded-[30px] bg-[#213a57] text-[#80ed99]  border-[2px] hover:border-[#0ad2c8] border-white  text-[25px]' >Download</button>
        </div>
        <div className='flex-[7] flex flex-col items-start h-auto p-6 '>
          <h1 className='text-3xl md:text-5xl font-bold self-center text-[#80ed99] text-center'>
            ABOUT ME!
          </h1>
          <h1 className='font-sans text-[15px] md:text-[20px] self-center mt-[-20px] text-[#a7abdf]'>
            who am i?
          </h1>
          <div className='text-sm md:text-xl text-white text-left mt-4'>
            Hello! I'm <b className='text-[#5949d6] font-extrabold text-xl md:text-3xl'>Mukund Hadiya</b>, a passionate
            <b className='text-[#80ed99] font-extrabold  md:text-2xl'> MERN STACK DEVELOPER</b> with expertise in
            <b className='text-[#80ed99] font-extrabold md:text-3xl'> Internet of Things (IoT)</b> devices.
            My journey in the tech world began with a curiosity to explore and innovate.
            <br />Over the years, I've honed my skills in technologies like <b className='text-[#80ed99] font-extrabold md:text-3xl'>ReactJs, NodeJs, ExpressJS, MongoDB Atlas, and more.</b>
            <br />What sets me apart is my knack for self-learning and my ability to translate complex ideas into user-friendly solutions. Whether it's crafting intuitive UI designs or solving intricate coding puzzles, I thrive on challenges that push me to grow.
            <br />I'm on a quest for a career opportunity that not only allows me to apply my expertise but also provides a platform for continuous learning and professional development. I'm excited about the prospect of contributing to impactful projects and building a brighter future in the IT industry.
          </div>
        </div>
      </div>
    </div>
  );
}
